export function conclaveEventPath(
  eventId: string,
  communityId?: string | null
): string {
  if (communityId) return `/${communityId}/events/${eventId}`;
  return `/e/${eventId}`;
}

export function conclaveSubPath(
  eventId: string,
  sub: 'live' | 'profile' | 'organise',
  communityId?: string | null
): string {
  return `${conclaveEventPath(eventId, communityId)}/conclave/${sub}`;
}
